import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { ProductCard } from "@/components/ProductCard";
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";
import api, { sortOffersFirst } from "@/lib/api";

export default function Shop() {
  const [searchParams, setSearchParams] = useSearchParams();
  const category = searchParams.get("category") || "";
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/products/categories").then(({ data }) => setCategories(data)).catch(() => {});
  }, []);

  useEffect(() => {
    setLoading(true);
    api
      .get("/products", { params: category ? { category } : {} })
      .then(({ data }) => setProducts(sortOffersFirst(data)))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [category]);

  const setCategory = (c) => {
    if (c) setSearchParams({ category: c });
    else setSearchParams({});
  };

  return (
    <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8" data-testid="shop-page">
      <div className="mb-8">
        <span className="text-xs font-semibold uppercase tracking-[0.2em] text-accent">Magazin</span>
        <h1 className="mt-2 font-heading text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
          {category || "Toate produsele"}
        </h1>
      </div>

      <div className="mb-10 flex flex-wrap gap-2">
        <Button
          variant={category === "" ? "default" : "outline"}
          onClick={() => setCategory("")}
          className="rounded-full"
          data-testid="filter-all"
        >
          Toate
        </Button>
        {categories.map((c) => (
          <Button
            key={c}
            variant={category === c ? "default" : "outline"}
            onClick={() => setCategory(c)}
            className="rounded-full"
            data-testid={`filter-${c}`}
          >
            {c}
          </Button>
        ))}
      </div>

      {loading ? (
        <div className="flex min-h-[40vh] items-center justify-center">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
        </div>
      ) : products.length === 0 ? (
        <p className="py-20 text-center text-slate-500" data-testid="empty-products">
          Nu există produse în această categorie.
        </p>
      ) : (
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {products.map((p, i) => (
            <ProductCard key={p.id} product={p} index={i} />
          ))}
        </div>
      )}
    </div>
  );
}
